import { Injectable } from '@angular/core';
import { TranslationService as CommonTranslationService } from 'common-framework';

@Injectable({
  providedIn: 'root'
})
export class TranslationService extends CommonTranslationService{

}
